import type { DataChartStyleProps } from './datachartStyleRegistry'
import './PresenceActivity.css'
import { usePresenceActivityData } from './usePresenceActivityData'

export function PresenceActivityStyle01(props: DataChartStyleProps) {
  const { bars, loading, empty } = usePresenceActivityData(props.deviceSN, props.credentials)

  return (
    <div className="presence-activity" data-css-slot="cardFrame" data-css-slot-label="Card Frame">
      <section
        className="presence-activity__activity"
        data-css-slot="activityCard"
        data-css-slot-label="Presence Activity Card"
      >
        <div className="presence-activity__activity-head">
          <div className="presence-activity__activity-title-wrap">
            <span className="material-symbols-outlined presence-activity__activity-icon">monitoring</span>
            <span>24h Activity</span>
          </div>
          <span className="material-symbols-outlined presence-activity__activity-chevron">chevron_right</span>
        </div>
        <div
          className="presence-activity__activity-bars"
          data-css-slot="activityBars"
          data-css-slot-label="24h Activity Bars"
        >
          {bars.map((value, index) => (
            <div
              key={`${value}-${index}`}
              className={`presence-activity__activity-bar ${value >= 50 ? 'is-active' : ''}`}
              style={{ height: `${value}%` }}
            />
          ))}
        </div>
        {loading ? (
          <div className="presence-activity__activity-status">Loading…</div>
        ) : empty ? (
          <div className="presence-activity__activity-status is-empty">No activity data</div>
        ) : null}
        <div
          className="presence-activity__activity-axis"
          data-css-slot="activityAxis"
          data-css-slot-label="24h Activity Axis"
        >
          <span>00:00</span>
          <span>12:00</span>
          <span>23:59</span>
        </div>
      </section>
    </div>
  )
}
